import { Reducer, Action } from 'redux'
import {
  CLEAR_ERROR_MESSAGES,
  SEARCH_USER_ACTION_TYPES,
  CREATE_USER_ACTION_TYPES,
  CREATE_CHILD_USER_ACTION_TYPES,
  USER_UPDATE_ACTION_TYPES,
} from 'utils/actions/user'
import { IUser, IChildUser, ISearchedUser, IUserCreationState } from 'apps/user/types/user'
import { transformUserSearchResponse } from 'apps/user/utils/userCreate'

const { SEARCH_USER_FAILURE, SEARCH_USER_REQUEST, SEARCH_USER_SUCCESS } = SEARCH_USER_ACTION_TYPES

const { CREATE_USER_FAILURE, CREATE_USER_REQUEST, CREATE_USER_SUCCESS } = CREATE_USER_ACTION_TYPES

const {
  CREATE_CHILD_USER_FAILURE,
  CREATE_CHILD_USER_REQUEST,
  CREATE_CHILD_USER_SUCCESS,
} = CREATE_CHILD_USER_ACTION_TYPES

const { USER_UPDATE_FAILURE, USER_UPDATE_REQUEST, USER_UPDATE_SUCCESS } = USER_UPDATE_ACTION_TYPES

interface IUserCreateAction {
  type: string
  error?: string
  payload: {
    user?: IUser | IChildUser
  }
}

interface IUserSearchAction {
  type: string
  error?: string
  payload: {
    namesearch?: ISearchedUser[]
  }
}

type ActionType = Action<string> | IUserCreateAction | IUserSearchAction

const defaultState: IUserCreationState = {
  searchedUsers: undefined,
  user: undefined,
  isCreatingUser: false,
  isSearchingUser: false,
  userSearchError: undefined,
  userCreateError: undefined,
}

const userCreateReducer: Reducer<IUserCreationState, ActionType> = (
  state = defaultState,
  action
) => {
  if (!action) return state

  switch (action.type) {
    case CREATE_CHILD_USER_REQUEST:
    case CREATE_USER_REQUEST: {
      return {
        ...state,
        isCreatingUser: true,
        userCreateError: undefined,
      }
    }
    case CREATE_CHILD_USER_FAILURE:
    case CREATE_USER_FAILURE: {
      const { error } = action as IUserCreateAction
      return {
        ...state,
        isCreatingUser: false,
        userCreateError: error || 'An error occurred while creating the user',
      }
    }
    case CREATE_CHILD_USER_SUCCESS:
    case CREATE_USER_SUCCESS: {
      const {
        payload: { user },
      } = action as IUserCreateAction
      return {
        ...state,
        isCreatingUser: false,
        user,
      }
    }
    case USER_UPDATE_REQUEST: {
      return {
        ...state,
        isCreatingUser: true,
        userCreateError: undefined,
      }
    }
    case USER_UPDATE_FAILURE: {
      const { error } = action as IUserCreateAction
      return {
        ...state,
        isCreatingUser: false,
        userCreateError: error || 'An error occurred while creating the user',
      }
    }
    case USER_UPDATE_SUCCESS: {
      const {
        payload: { user },
      } = action as IUserCreateAction
      return {
        ...state,
        isCreatingUser: false,
        user,
      }
    }
    case SEARCH_USER_REQUEST: {
      return {
        ...state,
        searchedUsers: undefined,
        isSearchingUser: true,
        userSearchError: undefined,
      }
    }
    case SEARCH_USER_FAILURE: {
      const { error } = action as IUserSearchAction
      return {
        ...state,
        isSearchingUser: false,
        userSearchError: error || 'An error occurred while searching for the user',
      }
    }
    case SEARCH_USER_SUCCESS: {
      const {
        payload: { namesearch },
      } = action as IUserSearchAction
      const searchedUsers = namesearch!.map(transformUserSearchResponse)

      return {
        ...state,
        searchedUsers,
        isSearchingUser: false,
      }
    }
    case CLEAR_ERROR_MESSAGES: {
      return {
        ...state,
        userSearchError: undefined,
        userCreateError: undefined,
      }
    }
    default:
      return state
  }
}

export default userCreateReducer
